import React from 'react'
import PropTypes from 'prop-types'
import { FromRadioWrapper, RadioLabel, RadioButton, RadioText } from './styled'

const FromRadio = ({ name, value, options, onChange }) => (
  <FromRadioWrapper>
    {
      options && options.map((option, index) => (
        <RadioLabel key={index}>
          <RadioButton type="radio" name={name} value={option.value} onChange={onChange} checked={value === option.value} hidden />
          <RadioText>{option.label}</RadioText>
        </RadioLabel>
      ))
    }
  </FromRadioWrapper>
)

FromRadio.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
}

FromRadio.defaultProps = {
  options: [
    { value: '', label: 'Label' }
  ],
  onChange: () => { }
}

export default FromRadio
